import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/service/common.service';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { IonInfiniteScroll } from '@ionic/angular';
import { WebParameterContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-new-councilor-kpi',
  templateUrl: './new-councilor-kpi.component.html',
  styleUrls: ['./new-councilor-kpi.component.scss']
})
export class NewCouncilorKpiComponent extends GridBaseCase {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  tabinde :number = 1;
  tabindexall:number = 1;
  beginDate:any = null;//开始日期
  endDate:any = null;//结束日期
  monthdate:any = null; //销量日期
  attainmentName:any = "";
  RecordCount: Number = 0;//列表总数量
  RecordCount2: Number = 0;//列表总数量
  dataArrayList: Array<any> = []; // 销量列表
  dataArrayListone: Array<any> = []; // 招募会员列表
  dataArrayListtwo: Array<any> = []; // 招募会员列表
  memberKpi:Array<any>=[];//招募会员统计
  saleKpi:Array<any>=[];//销量统计
  dataTwo:any={};//目标统计数据2222
  datatkpi: any = {maminfo:{},meminfo:{}}; // 妈妈新客/忠实会员
  RecordCountone:Number = 0; // 招募会员列表
  selectValVal=null;
  selectVal = null;//搜索月份
  rStore:string="";//门店
  saleMonthVal=null;
  saleMonth = null;//搜索月份
  saleStore:string="";//门店
  pageNumber2:number=1;
  sureShow:boolean=false;//IosselectDateTime start end date 比较
  pageName: string = null;
  pgId:string = null;
  storeId:string = null;
  a_FK_TBStore_ID:any; // 门店id
  
   nameTitle :any;
   nameTitle1:any;
   nameNumber:number=0;
   nameNumber1:number=0;
   numpercent:any; //达成率值
   apiObj1 = {
    status: false,
    msg: '',
    loading:false
};//接口状态

apiObj2 = {
  status: false,
  msg: '',
  loading:false
};//接口状态
  
  constructor(
    private com: CommonService,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService
  ) { 
    super();
    this.beginDate = this.com.getYearMonth;
    this.endDate = this.com.getYearMonth;
    this.monthdate= this.com.getYearMonth;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.pgId = this.com.GetAccount.Id;
    if(this.com.GetStorageKey("tbstore")){
      this.storeId=this.com.GetStorageKey("tbstore")["ID"];
    }
    const _paramId = this.activaRouter.snapshot.paramMap.get("id");
    activaRouter.queryParams.subscribe(queryParams => {
      if(queryParams.ID){
        this.storeId = queryParams.ID;// 门店id
        this.pgId=null;
      }
      if(queryParams.yearmonth){
        this.beginDate = queryParams.yearmonth;
        this.monthdate= queryParams.yearmonth;
      }
      const _date = new Date();
      const _month = _date.getMonth() + 1;
      this.selectVal = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";
      this.selectValVal = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month);
      this.saleMonthVal = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month);
      this.saleMonth = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";
      console.log(this.a_FK_TBStore_ID,"门店id***************************")
  });
  this.recruitNember(1); // 招募会员列表
  this.TargetSc();
  }
  // 切换显示
  tabEven(num){
    const that = this;
    that.tabinde = num;
    if( that.tabinde == 2 ){
      // debugger;
      that.salesNemberList(1);
      that.TargetScTwo();
    }
    if(that.tabinde == 1){
      that.recruitNember(1);
      that.TargetSc();
    }
  }
  // 销量类别切换显示
  // 切换显示
  tabEventdetail(num){
    const that = this;
    that.tabindexall = num;
    that.salesNemberList(1);
  }
  dateSeach(){
    const that = this;
    that.sureShow= true;
  }

 
    // 销量日期查询
    saledateSeach(){
      console.log("测试1");
      let that = this;
     
      console.log(that.monthdate);
      let _obj = {
        value: that.monthdate,
        format: "yyyymm"
      };
      that.native.IosselectDateTime(_obj).then(data => {
        that.monthdate = that.formatDate(data.value);
        console.log("测试");
        that.salesNemberList(1);
        
      }).catch(eror => {
        console.log(eror);
      });
    }
  formatDate(date) {
    if (date) {
      let _y = date.split("-")[0];
      let _m = date.split("-")[1];
      // let _d = _date.getDate();
      // return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
      return _y + "/" + (_m < 10 ? "0" + _m : _m);
    } else {
      return date;
    }
  }
    
    // 选择日期结束
    dissModal(){
      const that = this;
      that.sureShow= false;
    }
  // 点击查询开始时间结束时间时间段
  seach(){
    console.log("查询")
    const that =this;
    that.sureShow= false;
    let beginDate = new Date(that.beginDate.replace(/-/g,"/")).getTime();
    // let endDate = new Date(that.endDate.replace(/-/g,"/")).getTime();
    // if(endDate<= beginDate){
    //   that.msg.Alert("结束日期必须要大于开始日期哦！");
    //   return;
    // }
    that.TargetSc();
    that.recruitNember(1);

  }
  // 销量搜索
  salesReport(){
    const that =this;

    if(!that.monthdate){
        that.msg.Alert("日期不能为空哦！请选择日期");
        return;
    }
    that.salesNemberList(1);
     
  }

  
  /**
   * 招募会员 查询事件
   */
  searchEvent()
  {
    const that=this;
      that.recruitNember(1);
      that.TargetSc();
  }

  searchEvent2()
  {
    const that=this;
    that.salesNemberList(1);
    that.TargetScTwo();
  }
    /**
   * 选择日期
   * @param $event 
   */
  dateChange($event,type){
    console.log("datechange");
    let that = this;
    if(type=="date")
    {
      const date = $event.target.value || "";
      that.selectVal=date+"-01";
    }
      that.TargetSc();
      that.recruitNember(1);
  }

  dateChangeTwo($event)
  {
    let that = this;
    const date = $event.target.value || "";
    that.saleMonthVal=date+"-01";
    that.TargetScTwo();
    that.salesNemberList(1);
  }
  recruitNember(PageNumber){
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
      that.dataArrayListone = [];
    }            
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "get_PPSORPGSMTDKPI";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    let typeObj = {};
    typeObj["date"]=that.selectVal;
    typeObj["query"]=that.rStore;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayListone = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        let _data=data.Status.StoreInfo||[];
        data.Status.Datas=_data;
        data.Status.Datas.forEach(function (item) {
          that.dataArrayListone.push({
            "StoreName":item.StoreName,
            "title":"妈妈新客",
            "bmsprice":item.CountMMP,
            "bmssales":item.newclientMaMaVolume
           },{
             "StoreName":item.StoreName,
             "title":"忠实会员",
             "bmsprice":item.CountLoyal,
             "bmssales":item.newclientIMFVolume
           },{
            "StoreName":item.StoreName,
            "title":"守护计划",
            "bmsprice":item.CountTepei,
            "bmssales":item.newclienttepeiVolume,
            "type" : 1
           });
        });
        /****上拉加载数据begin****/
        that.RecordCountone = data.Status.RecordCount;
        if (that.RecordCountone == data.Status.Datas.length || that.RecordCountone == (that.dataArrayListone.length/2)) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }else{
        that.apiObj['status'] = false;
        that.apiObj['msg'] =data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }

    /** 第一个列表
   * 我的kpi指标接口
   */
  TargetSc(){
    var that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "getAllSncReach";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.ClientType = 2;
    that.memberKpi=[];
    // that.apiObj1.status=true;
    that.apiObj1.loading = false;
    that.apiObj1['status'] = false;
    that.apiObj1['msg'] = '';
    let typeObj = {};
    typeObj["date"]=that.selectVal;
    typeObj["query"] = that.rStore;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.apiObj1['status'] = data.ResponseMessage.Success;
      that.apiObj1['msg'] = data.ResponseMessage.ErrorMessage;
      that.apiObj1.loading = true;
      if (data.ResponseMessage.Success) {
        that.memberKpi = new Array<any>();
      let tempobj:any=data.Status||{};
       let c={};
          c["title"]="妈妈新客";
          c["MMPTarget"]=tempobj["MMPTarget"];//目标
          c["CountMMP"]=tempobj["CountMMP"];//达成
        
       that.memberKpi.push(c);
       let zs={};
            zs["title"]="忠实会员";
            zs["MMPTarget"]=tempobj["LoyalTarget"];//目标
            zs["CountMMP"]=tempobj["CountLoyal"];//达成
            that.memberKpi.push(zs);
            let tepei ={};
            tepei["title"]="守护计划";
            tepei["type"]=1;
            tepei["MMPTarget"]=tempobj["TePeiTarget"];//目标
            tepei["CountMMP"]=tempobj["CountTePei"];//达成
            that.memberKpi.push(tepei);
         that.apiObj1.status=true;
      }else{
        that.memberKpi=new Array<any>();

        that.apiObj1['status'] = false;
        that.apiObj1['msg'] =data.ResponseMessage.ErrorMessage;
        that.apiObj1.loading = true;
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.memberKpi=new Array<any>();
      error.ResponseMessage={};
      that.apiObj1.msg=error.ResponseMessage.ErrorMessage;
      that.apiObj1['status'] = false;
      that.apiObj1.loading = true;
    });
  }

  /**
   * 招募会员接口
   * 
   * 获取
   */

  loadMoreData(event) {
    let that = this;
    if (that.RecordCountone == (that.dataArrayListone.length/2)) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      that.recruitNember(that.PageNumber);
    }
  }
  // 销量会员列表
  /**
   * 
   * @param pageName 
   * saletyp kpi分类 brandtype 品牌分类    producttype 产品品类
   */
  loadMoreData1(event) {
    let that = this;
    if (that.RecordCount == (that.dataArrayList.length/2)) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.pageNumber2++;
      that.salesNemberList(that.pageNumber2);
    }
  }

      /** 第222个列表
   * 我的kpi指标接口
   */
  TargetScTwo(){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "getAllSncSales";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.ClientType = 2;
     that.saleKpi=new Array<any>();
     that.apiObj2['status'] = false;
     that.apiObj2['msg'] ='';
     that.apiObj2.loading = false;
    let typeObj = {};
    typeObj["date"]=that.saleMonth;
    typeObj["query"] = that.saleStore;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
        that.saleKpi=new Array<any>();
        that.apiObj2['status'] = data.ResponseMessage.Success;
        that.apiObj2['msg'] = data.ResponseMessage.ErrorMessage;
        that.apiObj2.loading = true;
      if (data.ResponseMessage.Success) {
        let temsale:any=data.Status||{};
        that.saleKpi.push({
          "title":"BMS产品供应预估准确度",
          "BMSVolume":temsale["BMSVolume"],//目标
          "BMSPrice":temsale["BMSPrice"]//达成
        },{
          "title":"Non-BMS",
          "BMSVolume":temsale["NonBMSVolume"],
          "BMSPrice":temsale["NonBMSPrice"]
        });
      }else{
        that.apiObj2['status'] = false;
        that.apiObj2['msg'] =data.ResponseMessage.ErrorMessage;
        that.apiObj2.loading = true;
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.saleKpi=new Array<any>();
      that.apiObj2['status'] = false;
      that.apiObj2['msg'] =error.ResponseMessage.ErrorMessage;
      that.apiObj2.loading = true;
      // console.log(error);
    });
  }
  /**
   * 销量第二tab门店
   * @param PageNumber 
   */
  salesNemberList(PageNumber){
    var that = this;
    if (that.pageNumber2 == 1) {
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "get_PPSORPGSMTDKPI";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
 
    body.PageNumber = that.pageNumber2;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let typeObj = {};
    // typeObj["a_FK_SystemUser_ID"] = that.pgId;
    // typeObj["a_UpTime"] = that.monthdate+"/01";
    // typeObj["StoreId"]=that.storeId;

    typeObj["date"]=that.saleMonth;
    typeObj["query"]=that.saleStore;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        let _data=data.Status.StoreInfo||[];
        data.Status.Datas=_data;
        data.Status.Datas.forEach(function (item) {
          that.dataArrayList.push({
           "StoreName":item.StoreName,
           "title":"BMS产品供应预估准确度",
           "bmsprice":item.bmsprice,
           "bmssales":item.bmssales
          },{
            "StoreName":item.StoreName,
            "title":"Non-BMS",
            "bmsprice":item.nonbmsprice,
            "bmssales":item.nonbmssales
          });
        });
        /****上拉加载数据begin****/
        if(data.Status.RecordCount==0)
        {
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }
        that.RecordCount = data.Status.RecordCount;
        if (that.dataArrayList == data.Status.Datas.length || that.RecordCount == (that.dataArrayList.length/2)) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }
  
}

